import * as Preact from "preact"

import "./DiceCube.less"
import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import DiceFace from "@fae/source/data/games/ember/views/DiceFace.jsx"
import Unit from "@fae/source/models/Unit.js"

export default function DiceCube() {
    // DICE TODO: THIS IS EDITING THE UNIT!! WHOOPS
    const items = Unit.items({
        "stage": this.props.stage,
        "unit": this.props.unit
    })
    if(items == undefined) return
    items[0] = items[0] ?? null
    items[1] = items[1] ?? null
    items[2] = items[2] ?? null
    items[3] = items[3] ?? null
    items[4] = items[4] ?? null
    items[5] = items[5] ?? null
    let equippedItem = this.props.item ?? this.props.unit.equippedItem
    let faceIndex = Object.values(items).indexOf(equippedItem)
    if(faceIndex < 0) faceIndex = undefined
    faceIndex = faceIndex ?? this.props.faceIndex

    if(this.props.item == undefined) return

    return (
        <div class="DiceCube">
            <div class="Cube" animation={this.props.animation || "none"} faceIndex={faceIndex} style={{
                "animation-duration": this.props.animation == "roll" && 0.7 + ((this.props.unit.rollingIndex ?? 0) * 0.2) + "s",
            }}>
                {Object.keys(items).map((key, index) => {
                    const item = items[key]
                    return (
                        <DiceFace item={item} unit={this.props.unit} stage={this.props.stage} index={index}/>
                    )
                })}
                <div class="InternalFace" index={0}/>
                <div class="InternalFace" index={1}/>
                <div class="InternalFace" index={2}/>
                <div class="InternalFace" index={3}/>
                <div class="InternalFace" index={4}/>
                <div class="InternalFace" index={5}/>
            </div>
        </div>
    )
}

// <div class="Dark Cube">
// </div>
